import type { Component } from 'vue';
import type { IconType } from '../Icon/Icon.model';
import {
	ContextPanelPosition,
	type ContextPanelConfig,
	ContextPanelConfigDefault,
} from '../ContextPanel/ContextPanel.model';
import type {
	DropdownAlign,
	DropdownItem,
	DropdownOption,
} from '../Dropdown/Dropdown.model';

export interface ContextMenuItem {
	id: string;
	disabled: boolean;
	locked: boolean;
	active: boolean;
	icon: IconType;
	label: string;
	link: string;
	action: (() => void) | undefined;
	items: Partial<ContextMenuItem>[];
}

export const ContextMenuItemDefault: Required<ContextMenuItem> = {
	id: '',
	disabled: false,
	locked: false,
	active: true,
	icon: '',
	label: '',
	link: '',
	action: undefined,
	items: [] as Required<ContextMenuItem>[],
};

export const ContextMenuPosition = ContextPanelPosition;
export type ContextMenuPosition =
	(typeof ContextMenuPosition)[keyof typeof ContextMenuPosition];
export type ContextMenuConfig = ContextPanelConfig;
export const ContextMenuConfigDefault = ContextPanelConfigDefault;

export type ContextMenuInstance = {
	id: string;
	items: DropdownOption[];
	x: number;
	y: number;
	align?: DropdownAlign;
	position?: 'fixed' | 'absolute';
	openUp?: boolean;
	fullWidth?: boolean;
	minWidth?: number;
	anchor?: HTMLElement | null;
	beforeComponent?: Component | null;
	closeOnSelect?: boolean;
	onSelect?: (item: DropdownItem) => void;
	onClose?: () => void;
};

export const createContextMenuInstanceId = (prefix = 'context-menu') =>
	`${prefix}-${Math.random().toString(36).slice(2, 10)}`;

export const createContextMenuItem = (
	item: Partial<ContextMenuItem>
): ContextMenuItem => {
	return {
		...ContextMenuItemDefault,
		...item,
		items: item.items ? item.items.map(createContextMenuItem) : [],
	};
};

export class ContextMenuItemClass {
	id: string;
	disabled: boolean;
	active: boolean;
	icon: IconType;
	label: string;
	link: string;
	action: (() => void) | undefined;
	items: ContextMenuItemClass[];

	constructor(item: Partial<ContextMenuItem>) {
		this.id = item.id || '';
		this.disabled = item.disabled || false;
		this.active = item.active ?? true;
		this.icon = item.icon || '';
		this.label = item.label || '';
		this.link = item.link || '';
		this.action = item.action;
		this.items = item.items
			? item.items.map((value) => new ContextMenuItemClass(value))
			: [];
	}
}
